import React from 'react'
import { overallData } from '../Expirience/AddExp';
import QuestionairePart1 from '../Quetionaire/QuetionairePart1';

const Assesment = () => {
    const isAssessed = overallData === 0 ? false : true
    return (
        <div>
            {isAssessed ? <QuestionairePart1 /> : <h1>yoo</h1>}
        </div>
    )
}

export default Assesment;